import { Button, Divider, Input, Modal, Spin } from "antd";
import { useState } from "react";
import "./DealerSearch.scss";
import { useHistory } from "react-router-dom";

var axios = require("axios");
const DealerSearch = () => {
  var history = useHistory();
  const [searchFormValues, setSearchFormValues] = useState({
    mobile: "",
    id: "",
  });
  const [mobileGovIDError, setmobileGovIDError] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [apiError, setAPIError] = useState("");
  const [spinner, setSpinner] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleChange =
    (name: string) => (event: { target: { value: any } }) => {
      setSearchFormValues({ ...searchFormValues, [name]: event.target.value });
      if (name === "mobile") {
        setSearchFormValues({
          ...searchFormValues,
          mobile: event.target.value,
          id: "",
        });
      }
      setmobileGovIDError(false);
    };

  const onSubmit = (key: any) => {
    const data = JSON.stringify(searchFormValues);
    const url =
      searchFormValues.mobile !== ""
        ? process.env.REACT_APP_DEALER_BASE_URL +
          "customer?mobile=" +
          searchFormValues.mobile
        : "";
    if (
      /^([0-9]{8})\d+$/.test(searchFormValues.mobile) &&
      ((searchFormValues.mobile.startsWith("84", 0) &&
        searchFormValues.mobile.length < 13) ||
        searchFormValues.mobile.length < 11)
    ) {
      setSpinner(true);
      var config = {
        method: "get",
        url: url,
        data: data,
      };

      axios(config)
        .then((response: any) => {
          if (
            response.data &&
            response.data.status &&
            response.data.status.success
          ) {
            if (key === "search") {
              //navigate to profile
              history.push({
                pathname: "/Dealer/profile",
                state: { data: response.data.response, key: key },
              });
            } else {
              setAPIError("Number already registred");
              showModal();
            }
          } else {
            if (key === "search") {
              setAPIError(response.data.status.message);
              showModal();
            } else {
              //navigate to profile to registration
              history.push({
                pathname: "/Dealer/profile",
                state: { data: searchFormValues.mobile, key: key },
              });
            }
          }
          setSpinner(false);
        })
        .catch((error: any) => {
          setAPIError("Something went wrong. Please try again");
          showModal();
          setSpinner(false);
        });
    } else {
      setmobileGovIDError(true);
    }
  };

  const handleKeypress = (event: any) => {
    if (event.key === "Enter") {
      onSubmit("search");
    }
  };

  return (
    <>
      <div style={{ paddingBottom: 20 }}>
        <div className="SearchAndStatusContainer">
          <p className="title">Dashboard</p>
          <div className="SearchContainer">
            <div className="SearchUserDetails">
              <p className="formTitle">Search by User Details</p>

              <div className="formInput">
                <Divider></Divider>
                <label>Mobile Number</label>
                <Input
                  value={searchFormValues.mobile}
                  onChange={handleChange("mobile")}
                  placeholder="Enter Mobile Number"
                  onKeyPress={handleKeypress}
                />
              </div>
              {mobileGovIDError ? (
                <div>
                  <p className="errorText">Please Enter Valid Mobile Number</p>
                </div>
              ) : null}

              <div>
                <Button
                  type="primary"
                  style={{ maxWidth: "75%" }}
                  onClick={() => onSubmit("register")}
                >
                  Register
                </Button>
                <Button
                  type="primary"
                  style={{ maxWidth: "75%" }}
                  onClick={() => onSubmit("search")}
                >
                  Search
                </Button>
              </div>
            </div>
          </div>
          {spinner && <Spin tip="Loading..." />}
          <Modal
            title="Jotun Master Painter"
            onCancel={handleCancel}
            footer={null}
            visible={isModalVisible}
            onOk={handleOk}
          >
            <p>{apiError}</p>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default DealerSearch;
